module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAQAAACQTsNJAAAAtUlEQVR42u2WPQqEMBCFBfFg3iY5heQesQ5Y60WUNNvrNb5tZH8gmUTZsAvrpElI+Mh7U7ypqhJFi8YIS9PKgAbHjKUTlmXF08QhnoE6+deaARcXsqURO2aOiELRZztn0eGLjhvT4zQ998G3Jg4ZXyDjOYjJlvM/kEB9CXJ1J8vYsMHFIVd3Dhn7bm5xyK948pHIaFmyw2uNJjIuO0a9FOiejV6cCnoWnBDouyglTgUqMVqcrTtULcpkmQLDmQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/baseloan/assets/icon-tab-02-active.png
// module id = aVmc
// module chunks = 70